import {makeAutoObservable} from 'mobx';
// https://mobx.js.org/defining-data-stores.html

export default class CreateWidgetStore {
    isPanelNiveauxOpened = false;
    idWidgetModification = "";
    typeWidget = '';
    modalPrimary = { open: false, title: '', message: '', type: '' };


    constructor() {
        // makeAutoObservable
        // https://mobx.js.org/observable-state.html
        makeAutoObservable(this);
    }

    openModificationMode(idWidget, typeWidget) {
        if (typeof idWidget !== 'undefined') {
            if (typeof typeWidget !== 'undefined') {
                this.resetCreateWidget();
                this.idWidgetModification = idWidget;
                this.openFormulaireWidget(typeWidget);
            }
        }
    }

    openCreationMode(typeWidget) {
        if (typeof typeWidget !== 'undefined') {
            this.resetCreateWidget();
            this.openFormulaireWidget(typeWidget);
        }
    }

    openPanelNiveaux() {
        this.isPanelNiveauxOpened = true;
    }

    closePanelNiveaux() {
        this.isPanelNiveauxOpened = false;
    }

    openFormulaireWidget(typeWidget) {
        this.typeWidget = typeWidget || 'ChoixWidgetType';
    }

    resetCreateWidget() {
        this.typeWidget = '';
        this.idWidgetModification = "";
        this.closePanelNiveaux();
    }

    // Ajout de la méthode pour mettre à jour l'état du modal
    setModalPrimary(modalState) {
        this.modalPrimary = { ...this.modalPrimary, ...modalState };
    }

    openModalPrimary({ title, message, type }) {
        this.setModalPrimary({
            open: true,
            title,
            message,
            type
        });
    }

    closeModalPrimary() {
        this.setModalPrimary({ open: false });
    }

}
